import { authFetch } from '../utils/authFetch';
import { Integration, OrganizationIntegration } from '../types/integrations';

const API_BASE_URL = (process.env.REACT_APP_BACKEND_BASE_URL || 'http://localhost:8000') + '/api/v1';

export const integrationService = {
  // Get all available integrations
  async getAvailableIntegrations(accessToken: string, setUserAndToken: (user: any, token: string) => void): Promise<Integration[]> {
    const response = await authFetch(`${API_BASE_URL}/integrations/available`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }, accessToken, setUserAndToken);

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to fetch available integrations');
    }

    return response.json();
  },

  // Get integrations for a specific organization
  async getOrganizationIntegrations(organizationId: string, accessToken: string, setUserAndToken: (user: any, token: string) => void): Promise<OrganizationIntegration[]> {
    const response = await authFetch(`${API_BASE_URL}/integrations/organizations/${organizationId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }, accessToken, setUserAndToken);

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to fetch organization integrations');
    }

    return response.json();
  },

  // Create a new integration for an organization
  async createOrganizationIntegration(organizationId: string, integrationId: string, integrationName: string, accessToken: string, setUserAndToken: (user: any, token: string) => void): Promise<OrganizationIntegration> {
    const url = `${API_BASE_URL}/integrations/organizations/${organizationId}/integrations/${integrationId}/create?integration_name=${encodeURIComponent(integrationName)}`;

    
    const response = await authFetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }, accessToken, setUserAndToken);

    

    if (!response.ok) {
      const error = await response.json();
      console.error('❌ Service: Error response:', error);
      throw new Error(error.detail || 'Failed to create organization integration');
    }

    const result = await response.json();
    
    return result;
  },

  // Integration completion is handled automatically via webhooks
  // This method is not used in the current webhook-based flow
  // async completeOrganizationIntegration(...) - Removed as unused

  // Revoke an integration
  async revokeOrganizationIntegration(organizationId: string, integrationId: string, accessToken: string, setUserAndToken: (user: any, token: string) => void): Promise<OrganizationIntegration> {
    const response = await authFetch(`${API_BASE_URL}/integrations/organizations/${organizationId}/integrations/${integrationId}/revoke`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }, accessToken, setUserAndToken);

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to revoke organization integration');
    }

    return response.json();
  },

  // Get a specific integration for an organization
  async getOrganizationIntegration(organizationId: string, integrationId: string, accessToken: string, setUserAndToken: (user: any, token: string) => void): Promise<OrganizationIntegration> {
    const response = await authFetch(`${API_BASE_URL}/integrations/organizations/${organizationId}/integrations/${integrationId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }, accessToken, setUserAndToken);

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to fetch organization integration');
    }

    return response.json();
  },

  // Get an organization integration by its ID
  async getIntegrationById(integrationId: string, accessToken: string, setUserAndToken: (user: any, token: string) => void): Promise<OrganizationIntegration> {
    const response = await authFetch(`${API_BASE_URL}/integrations/integrations/${integrationId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }, accessToken, setUserAndToken);

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to fetch organization integration');
    }

    return response.json();
  },

  // Recreate an expired integration
  async recreateExpiredIntegration(organizationId: string, integrationId: string, accessToken: string, setUserAndToken: (user: any, token: string) => void): Promise<OrganizationIntegration> {
    const response = await authFetch(`${API_BASE_URL}/integrations/organizations/${organizationId}/integrations/${integrationId}/recreate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }, accessToken, setUserAndToken);

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to recreate expired integration');
    }

    return response.json();
  },


};
